import React from 'react'
import ReportSubtitleV1 from 'components/Text/ReportSubtitleV1'
import ReportSubtitle from 'components/Text/ReportSubtitle'
import useLanguage from 'features/languageReport/useLanguage'
import useStyles from 'components/molcules/N1SummaryReport/useStyles'
import {simpleSanitizeHTML} from 'helpers/analysisHelper'

export default function EEGChildSummaryFrontLobeDevelopmentAPI(props: {
  frontalLobeDevelopmentGraphImage: string | undefined
  // eslint-disable-next-line react/no-unused-prop-types
  frontalLobeDevelopmentColorbarImage: string | undefined
  percentile: number
  // maxRange: number
  score: number
  isSummary?: boolean
}) {
  const {frontalLobeDevelopmentGraphImage, percentile, score, isSummary} = props
  const {textEegAPI} = useLanguage('eeg')
  const classes = useStyles()

  return (
    <div className={classes.eeg}>
      {isSummary ? (
        <ReportSubtitleV1 number='1'>
          {textEegAPI?.infant_youth.section.frontal_development.title}
        </ReportSubtitleV1>
      ) : (
        <ReportSubtitle number='1'>
          {textEegAPI?.infant_youth.section.frontal_development.title}
        </ReportSubtitle>
      )}

      <div className={classes.childValueGraph}>
        <div className='Child-Graph'>
          {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
          <img
            src={frontalLobeDevelopmentGraphImage}
            alt='brain wave analysis 3d image'
          />
        </div>
        <div className='Child-info'>
          <div
            style={{
              backgroundColor: '#00a29c',
              color: '#FFF',
              padding: '15px 24px',
              marginTop: 84,
              marginBottom: 4,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <div className='Range'>
              <span
                style={{display: 'inline-block', maxWidth: '65%'}}
                // @ts-ignore
                // eslint-disable-next-line
                dangerouslySetInnerHTML={{
                  __html: simpleSanitizeHTML(
                    textEegAPI?.infant_youth.section.frontal_development
                      .score_bar.percentile ?? '',
                  ),
                }}
              />
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              {percentile == null && (
                // eslint-disable-next-line jsx-a11y/label-has-associated-control
                <label className='ScoreValue'>{`    - %ile`}</label>
              )}
              {percentile != null && (
                // eslint-disable-next-line jsx-a11y/label-has-associated-control
                <label className='ScoreValue'>{`${percentile} %ile`}</label>
              )}
            </div>
            <div
              className='Score scoreWrapText'
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <span>
                {
                  textEegAPI?.infant_youth.section.frontal_development.score_bar
                    .value
                }
              </span>
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              {score == null && (
                // eslint-disable-next-line jsx-a11y/label-has-associated-control
                <label className='ScoreNullValue'>-</label>
              )}
              {score != null && (
                <div>
                  <span className='ScoreValue'>{`${score}`}</span>
                </div>
              )}
            </div>
          </div>
          <div className='Child-info-alert'>
            {
              textEegAPI?.infant_youth.section.frontal_development.score_bar
                .annotation
            }
          </div>
          <div
            className='Title'
            style={{color: '#000000', marginBottom: '20px'}}
          >
            {
              textEegAPI?.infant_youth.section.frontal_development.description
                .main
            }
          </div>
          <div className='Desc' style={{color: '#333333'}}>
            {
              textEegAPI?.infant_youth.section.frontal_development.description
                .sub[0]
            }
            <br />
            {
              textEegAPI?.infant_youth.section.frontal_development.description
                .sub[1]
            }
          </div>
        </div>
      </div>
    </div>
  )
}
